// extracted by mini-css-extract-plugin
export var social = "gl_Sj";
export var social_link = "gl_Tj";